import Vue from 'vue';
import Vuex from 'vuex';
import exemption from './modules/exemption';
import user from './modules/user';
import exemptionExport from './modules/exemption_export';
import due from './modules/due';
import enterprise from './modules/enterprise';
import settings from './modules/settings';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        exemption,
        user,
        exemptionExport,
        due,
        enterprise,
        settings,
    }
});

